import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import PlantObligationSwitch from './PlantObligationSwitch';
import UserMark from './PlantObligationContainerElements/UserMark';
import ObligationCheckbox from './PlantObligationContainerElements/ObligationCheckbox';

const PlantObligationContainer = (props) => {
  const {
    plantObligationID, type,
  } = props;
  const obligationsCheckbox = useSelector((state) => state.currentPage?.options?.obligationsCheckbox);

  const [isMouseOver, setIsMouseOver] = useState(false);

  return (
    <Container
      className="pt-2"
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      <PreObligation>
        {obligationsCheckbox ? (
          <ObligationCheckbox
            plantObligationID={plantObligationID}
          />
        ) : (
          <UserMark
            plantObligationID={plantObligationID}
            isMouseOver={isMouseOver}
          />
        )}
      </PreObligation>

      <PlantObligationSwitch
        type={type}
        plantObligationID={plantObligationID}
      />
    </Container>
  );
};

export default PlantObligationContainer;

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;

const PreObligation = styled.div`
  height: 160px;
  display: flex;
  align-items: center;
`;
